// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@media (min-width: 1024px) {
  .wwicCzL_5Xu3AyeAz4UD {
    display: grid;
    grid_template_columns: repeat(12, 1fr);
    gap: 24px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .wwicCzL_5Xu3AyeAz4UD {
    display: grid;
    grid_template_columns: repeat(8, 1fr);
    gap: 16px;
  }
}
@media (max-width: 768px) {
  .wwicCzL_5Xu3AyeAz4UD {
    display: grid;
    grid_template_columns: repeat(4, 1fr);
    gap: 8px;
  }
}

/*Quando for aplicar o grid, colocar o seguinte código na div desejada e
alterar o "ComponentModule" pelo nome do modulo do seu scss

<div className={ComponentModule.gridMU}>exemplo grid</div>
*/
.z6_eALUIEjBos8kAkRpa {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  gap: 24px;
}
.z6_eALUIEjBos8kAkRpa .mnN_QoVGFIc3WfCX4hz7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}
.z6_eALUIEjBos8kAkRpa .mnN_QoVGFIc3WfCX4hz7 .qRiz5MhArjWfWZTQDlsG {
  display: flex;
  align-items: center;
  gap: 12px;
}
.z6_eALUIEjBos8kAkRpa .y0TGhit5wbEEjkracC7N {
  display: flex;
  flex-direction: column;
  gap: inherit;
}
.z6_eALUIEjBos8kAkRpa .y0TGhit5wbEEjkracC7N .XVT2rtkQii3ZHfVBtv6Q {
  display: flex;
  gap: 4px;
}
.z6_eALUIEjBos8kAkRpa .xmpTnquXa5P4Rn2i9iv0 {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.z6_eALUIEjBos8kAkRpa .XRnPCW7SCnzN1CYutGiJ {
  padding: 4px;
  display: flex;
  border-radius: 50%;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/componentes/ModalAlertaLicenca/modal-alerta-licenca.module.scss","webpack://./src/styles/_grid.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgEd;EADF;IArBE,aAAA;IACA,sCAAA;IACA,SAlBoB;EDpBpB;AACF;AC6DE;EALF;IAdE,aAAA;IACA,qCAAA;IACA,SAnBmB;EDnBnB;AACF;AC0DE;EATF;IAPE,aAAA;IACA,qCAAA;IACA,QApBmB;EDlBnB;AACF;;ACwDA;;;;CAAA;AD3EA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aCCU;EDAV,sBAAA;EACA,SCDU;AD4Bd;AAzBI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,SCZM;ADuCd;AA1BQ;EACI,aAAA;EACA,mBAAA;EACA,SChBE;AD4Cd;AAxBI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AA0BR;AAxBQ;EACI,aAAA;EACA,QC7BC;ADuDb;AAtBI;EACI,aAAA;EACA,yBAAA;EACA,SClCM;AD0Dd;AArBI;EACI,YCxCK;EDyCL,aAAA;EACA,kBAAA;EACA,eAAA;AAuBR","sourcesContent":["@use '../../styles/grid' as grid;\r\n\r\n.container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    padding: grid.$spacing-24;\r\n    box-sizing: border-box;\r\n    gap: grid.$spacing-24;\r\n\r\n    .cabecalho{\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        width: 100%;\r\n        gap: grid.$spacing-12;\r\n        .titulo{\r\n            display: flex;\r\n            align-items: center;\r\n            gap: grid.$spacing-12;\r\n        }\r\n    }\r\n\r\n    .corpo{\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: inherit;\r\n\r\n        .textoPrincipal {\r\n            display: flex;\r\n            gap: grid.$spacing-4;\r\n        }\r\n    }\r\n\r\n    .rodape{\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        gap: grid.$spacing-12;\r\n    }\r\n\r\n    .iconeFechar{\r\n        padding: grid.$spacing-4;\r\n        display: flex;\r\n        border-radius: 50%;\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n","//spacing\r\n\r\n$spacing-4 : 4px;\r\n$spacing-8 : 8px;\r\n$spacing-12 : 12px;\r\n$spacing-16 : 16px;\r\n$spacing-20 : 20px;\r\n$spacing-24 : 24px;\r\n$spacing-32 : 32px;\r\n$spacing-40: 40px;\r\n$spacing-48 : 48px;\r\n$spacing-56: 56px;\r\n$spacing-64 : 64px;\r\n$spacing-88 : 88px;\r\n$spacing-112 : 112px;\r\n$spacing-160 : 160px;\r\n$spacing-192 : 192px;\r\n$spacing-256 : 256px;\r\n$spacing-320 : 320px;\r\n$spacing-448: 448px;\r\n$spacing-512 : 512px;\r\n\r\n\r\n// Variáveis para grid desktop\r\n$grid_container_min_width_desktop: 1024px; // Defina o valor apropriado\r\n$grid_columns_desktop: 12;\r\n$grid_gutter_desktop: 24px;\r\n\r\n// Variáveis para grid tablet\r\n$grid_container_min_width_tablet: 768px;\r\n$grid_columns_tablet: 8;\r\n$grid_margin_tablet: 40px;\r\n$grid_gutter_tablet: 16px;\r\n\r\n// Variáveis para grid mobile\r\n$grid_container_min_width_mobile: 320px;\r\n$grid_columns_mobile: 4;\r\n$grid_margin_mobile: 20px;\r\n$grid_gutter_mobile: 8px;\r\n\r\n// Mixin para a grid _desktop\r\n@mixin make_grid_desktop($columns, $gutter_width) {\r\n  display: grid;\r\n  grid_template_columns: repeat($columns, 1fr);\r\n  gap: $gutter_width;\r\n}\r\n\r\n// Mixin para a grid _tablet\r\n@mixin make_grid_tablet($columns, $gutter_width) {\r\n  display: grid;\r\n  grid_template_columns: repeat($columns, 1fr);\r\n  gap: $gutter_width;\r\n}\r\n\r\n// Mixin para a grid _mobile\r\n@mixin make_grid_mobile($columns, $gutter_width) {\r\n  display: grid;\r\n  grid_template_columns: repeat($columns, 1fr);\r\n  gap: $gutter_width;\r\n}\r\n\r\n// Aplicando as grids\r\n\r\n.gridMU {\r\n  @media (min-width: $grid_container_min_width_desktop) {\r\n    @include make_grid_desktop($grid_columns_desktop, $grid_gutter_desktop);\r\n  }\r\n\r\n  @media (min-width: $grid_container_min_width_tablet) and (max-width: $grid_container_min_width_desktop) {\r\n    @include make_grid_tablet($grid_columns_tablet, $grid_gutter_tablet);\r\n  }\r\n\r\n  @media (max-width: $grid_container_min_width_tablet) {\r\n    @include make_grid_mobile($grid_columns_mobile, $grid_gutter_mobile);\r\n  }\r\n}\r\n\r\n/*Quando for aplicar o grid, colocar o seguinte código na div desejada e\r\nalterar o \"ComponentModule\" pelo nome do modulo do seu scss\r\n\r\n<div className={ComponentModule.gridMU}>exemplo grid</div>\r\n*/"],"sourceRoot":""}]);
// Exports
export var gridMU = `wwicCzL_5Xu3AyeAz4UD`;
export var container = `z6_eALUIEjBos8kAkRpa`;
export var cabecalho = `mnN_QoVGFIc3WfCX4hz7`;
export var titulo = `qRiz5MhArjWfWZTQDlsG`;
export var corpo = `y0TGhit5wbEEjkracC7N`;
export var textoPrincipal = `XVT2rtkQii3ZHfVBtv6Q`;
export var rodape = `xmpTnquXa5P4Rn2i9iv0`;
export var iconeFechar = `XRnPCW7SCnzN1CYutGiJ`;
export default ___CSS_LOADER_EXPORT___;
